import { useEffect, useState } from 'react';
import {
  Button, Card, Typography, Alert, Space, InputNumber, Form,
} from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from 'react-query';
import httpService from 'services/http.service';
import { API_URLS } from 'config/constants';

const { Title, Text } = Typography;

interface ISettings {
  toysiMarkupPercent: number;
  promMarkupPercent: number;
}

async function getSettings(): Promise<ISettings> {
  const { data } = await httpService.get(API_URLS.SETTINGS.GET);
  return data;
}

async function updateSettings(dto: ISettings): Promise<ISettings> {
  const { data } = await httpService.put(API_URLS.SETTINGS.UPDATE, dto);
  return data;
}

const SettingsPage = () => {
  const [form] = Form.useForm<ISettings>();
  const [saved, setSaved] = useState(false);

  const { data, isLoading } = useQuery('settings', getSettings);

  useEffect(() => {
    if (data) form.setFieldsValue(data);
  }, [data]);

  const { mutate, isLoading: isSaving, isError, error } = useMutation(updateSettings, {
    onSuccess: (result) => {
      form.setFieldsValue(result);
      setSaved(true);
    },
  });

  return (
    <Card style={{ maxWidth: 600, margin: '24px auto' }}>
      <Title level={4}>Налаштування</Title>

      <Space direction='vertical' size='middle' style={{ width: '100%' }}>
        <Text type='secondary'>
          Націнка, яка додається до ціни постачальника Toysi при імпорті товарів
          та при щогодинному синку цін/залишків.
        </Text>

        <Form
          form={form}
          layout='vertical'
          disabled={isLoading}
          onFinish={(values) => { setSaved(false); mutate(values); }}
        >
          <Form.Item
            label='Націнка Toysi, %'
            name='toysiMarkupPercent'
            rules={[{ required: true, message: 'Вкажіть відсоток націнки' }]}
          >
            <InputNumber min={0} max={1000} style={{ width: '100%' }} />
          </Form.Item>

          <Text type='secondary' style={{ display: 'block', marginBottom: 12 }}>
            Націнка тільки для фіда Prom.ua — не впливає на ціни на сайті та в Google-фіді.
            Застосовується до ціни товару, а вже потім на неї накладається знижка Prom (мінімум 10%),
            яка показується в фіді завжди.
          </Text>

          <Form.Item
            label='Націнка для фіда Prom, %'
            name='promMarkupPercent'
            rules={[{ required: true, message: 'Вкажіть відсоток націнки' }]}
          >
            <InputNumber min={0} max={1000} style={{ width: '100%' }} />
          </Form.Item>

          <Button
            type='primary'
            icon={<SaveOutlined />}
            htmlType='submit'
            loading={isSaving}
            size='large'
          >
            Зберегти
          </Button>
        </Form>

        {saved && (
          <Alert type='success' message='Налаштування збережено' showIcon />
        )}

        {isError && (
          <Alert
            type='error'
            message='Помилка збереження'
            description={(error as any)?.message || 'Невідома помилка'}
            showIcon
          />
        )}
      </Space>
    </Card>
  );
};

export default SettingsPage;
